const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ './pages/login.vue'),
    meta: {
      showForAllLoggedUsers: false,
      showForGuestUsers: true,
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName: "auth" */ './pages/logout.vue'),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: false,
    },
  },
  {
    path: '/password',
    name: 'ForgottenPassword',
    component: () => import(/* webpackChunkName: "auth" */ './pages/forgotten-password.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/valid-resetpassword-token',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "auth" */ './pages/reset-password.vue'),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "auth" */ './pages/register.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/verify-token',
    name: 'VerifyToken',
    component: () => import(/* webpackChunkName: "auth" */ './pages/verify-token.vue'),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
  {
    path: '/force-change-password',
    name: 'ForceChangePassword',
    component: () => import(/* webpackChunkName: "auth" */ './pages/force-change-password.vue'),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: false,
    },
  },
  {
    path: '/force-enter-foip',
    name: 'ForceEnterFoip',
    component: () => import(/* webpackChunkName: "auth" */ './pages/force-enter-foip.vue'),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: false,
    },
  },
  {
    path: '/valid-resetpassword-token-no-qustions',
    name: 'ResetPasswordWithoutSecurityQuestions',
    component: () => import(/* webpackChunkName: "auth" */ './pages/reset-password-without-security-questions.vue'),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
  {
    path: '/valid-resetpassword-token-scc',
    name: 'ResetPasswordSCC',
    component: () => import(/* webpackChunkName: "auth" */ './pages/reset-password-scc.vue'),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
  {
    path: '/session-expired',
    name: 'SessionExpired',
    component: () => import('./pages/session-expired.vue'),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
];

export default routes;
